export const tableData = {
  tHead: [
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
      width: '350px'
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '质量等级',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'label1str',
      dataIndex: 'label1str',
      title: '',
      slot:'operate2019',
    },
    {
      key: 'label2str',
      dataIndex: 'label2str',
      title: '',
      slot:'operate2020',
    },
    {
      key: 'label3str',
      dataIndex: 'label3str',
      title: '',
      slot:'operate2021',
    },
    {
      title: '评分详情',
      slot:'operatehz',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 50
  },
};
export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '评估指标',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'label1str',
      dataIndex: 'label1str',
      title: '',
      slot:'operate2019',
    },
    {
      key: 'label2str',
      dataIndex: 'label2str',
      title: '',
      slot:'operate2020',
    },
    {
      key: 'label3str',
      dataIndex: 'label3str',
      title: '',
      slot:'operate2021',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
